import { FileExtension, IFileExtensionContext } from 'tessa/ui/files';
import { Card, CardSection } from 'tessa/cards';
import { MenuAction, SeparatorMenuAction } from 'tessa/ui';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { PkCardTypes } from 'src/pkScripts/Helpers/PkCardTypes';
import { CdContextMenuFileHelper } from './CdContextMenuFileHelper';
import { CdFileTypes } from '../Helpers/CdFileTypes';
import { CdExecutiveDocumentationClientHelper } from '../Helpers/Cards/CdExecutiveDocumentationClientHelper';

export class CdGetFileForPrintContextMenuFileExtension extends FileExtension {
  public openingMenu(context: IFileExtensionContext) {
    let card: Card = context.control.model.card;
    if (card.typeId !== CdCardTypes.PkExecutiveDocumentationTypeID
      && card.typeId !== CdCardTypes.PkExecutiveSchemeTypeID
      && card.typeId !== CdCardTypes.PkRequestForMaterialsTypeID
      && card.typeId !== PkCardTypes.PkMemoTypeID
      && card.typeId !== CdCardTypes.TechnicalDocumentationTypeID) {
      return;
    }

    // @ts-ignore
    let cardFile = card.files.find(x => x.rowId === context.file.id).card;
    let fileES = card.files.find(x => x.rowId === context.file.id);

    if (fileES && card.info[fileES.name] != null && card.info[fileES.name].$value) {
      const cardExecutiveSchemeID = card.info[fileES.name].$value;

      // проверка наличия подписей виртуального файла происходит на сервере class: CdExecutiveDocumentationGetExtension
      this.AddMenuAction(context, () => CdContextMenuFileHelper.SaveFileForPrintVirtual(cardExecutiveSchemeID, context.file.id));
      return;
    }

    // Если у файла нет подписей
    if (!cardFile.sections.has('FileSignatures') ||
        // @ts-ignore
        cardFile.sections.get('FileSignatures').rows.length === 0) {
      return;
    }

    // Если без ЭЦП
    if (card.typeId === CdCardTypes.PkExecutiveDocumentationTypeID) {
      let exeSect: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
      if (!exeSect) return;
      let signingTypeID: number | null = exeSect.fields.tryGet('SigningTypeID');
      if (!signingTypeID || signingTypeID === 0) {
        return;
      }
    }

    this.AddMenuAction(context, () => CdContextMenuFileHelper.SaveFileForPrint(context.file, card, CdFileTypes.GetFileForPrintType, card.typeId, card.typeName, CdExecutiveDocumentationClientHelper.PdfForPrint));
  }

  private AddMenuAction(context: IFileExtensionContext, action: any) {
    // Вставляем действие до ЭЦП
    let actionIndex: number | null = -1;
    context.actions.forEach(action => {
      if (action.name === 'SignEDS' || action.name === 'PkSignFile') {
        actionIndex = context.actions.indexOf(action);
      }
    });

    context.actions.splice(actionIndex, 0, new SeparatorMenuAction(false));

    context.actions.splice(
      actionIndex,
      0,
      new MenuAction(
        'GetFileForPrint',
        'Скачать печатную форму',
        "ta icon-thin-063",
        action,
        null,
        false
    ));
  }
}